<template>
	<section>
		<div v-if="news.list == false"></div>
		<div v-else class="iv2-section-news theme-b__home-news-bg">
			<div class="iv2-top-news__content container">
				<div class="row clearfix" draggable="false">
					<div class="column full text-center">
						<p class="m-0">{{ subtitle }}</p>
						<h3 class="theme__heading-text">{{ title }}</h3>
					</div>
				</div>
				<div class="row clearfix">
					<div class="column full">
						<div class="spacer height-40"></div>
					</div>
				</div>
				<div v-if="news.list" class="row clearfix">
					<div v-for="item in limitCount" :key="item.id" class="iv2-top-news-item my-4 col-12">
						<router-link :to="'/news/' + item.id" class="iv2-top-news-item__link">
							<div class="row">
								<div class="iv2-top-news-item__img fit-img col-md-4 col-12">
									<img
										:src="item.thumbnail"
										class="m-0"
										:alt="
                                            '「' + item.title + '」' + alt_text
                                        "
									/>
								</div>

								<div class="iv2-top-news-item__list col-md-8 col-12 px-md-5">
									<div class="d-flex">
										<p class="iv2-top-news-item__date">{{ item.created | moment }}</p>
										<p class="iv2-top-news-item__label size-14">{{ item.category_name }}</p>
										<p
											v-if="
                                                isAfter(
                                                    setDatetime(item.created),
                                                    end
                                                )
                                            "
											class="iv2-top-news-item__new ml-1 size-14"
										>{{ new_label }}</p>
									</div>
									<h3 class="iv2-top-news-item__title">{{ item.title }}</h3>
									<p class="iv2-top-news-item__summary">{{ item.body + "..." }}</p>
								</div>
							</div>
						</router-link>
					</div>
				</div>
				<div v-if="rss.outbound" class="row clearfix my-4">
					<div class="column full" style="margin: 0 auto;">
						<div style="text-align: center;">
							<span>
								<router-link
									to="/news"
									class="theme__main-btn is-btn is-btn-ghost2 is-upper size-18"
									style="border: 0; border-radius: 50px; letter-spacing: 2px; max-width: 100%; width: 300px; padding-top: 15px; padding-bottom: 15px; margin: 5px;"
								>{{ news_btn_text }}</router-link>
								<a
									v-if="rss.outbound.status == 1"
									:href="rss.outbound.href"
									target="_blank"
									rel="noopener"
									class="theme__main-btn is-btn is-btn-ghost2 is-upper size-18"
									style="border: 0; border-radius: 50px; letter-spacing: 2px; max-width: 100%; width: 300px; padding-top: 15px; padding-bottom: 15px; margin: 5px;"
								>
									<i class="fas fa-rss"></i>
									{{ rss_btn_text }}
								</a>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import moment from "moment";

export default {
	data() {
		return {
			news: [],
			rss: [],

			title: "お知らせ",
			subtitle: "News",
			new_label: "NEW",
			news_btn_text: "お知らせ一覧",
			rss_btn_text: "RSSフィード",
			alt_text: "のサムネイル",

			limit: 3,
			start: "",
			end: moment().format(),
		};
	},

	created() {
		this.axios.get("/json/news_list.json").then((response) => {
			this.news = response.data.news;
		});

		this.axios.get("/json/rss.json").then((response) => {
			this.rss = response.data.rss;
		});
	},

	methods: {
		isAfter: function (start, end) {
			return moment(start).isAfter(end);
		},

		setDatetime: function (start) {
			return moment(start).add(14, "days").format();
		},
	},

	computed: {
		limitCount() {
			return this.news.list.slice(0, this.limit);
		},
	},

	filters: {
		moment: function (created) {
			return moment(created).format("YYYY.MM.DD");
		},
	},
};
</script>

<style lang="scss">
.iv2-section-news {
	padding-bottom: 100px;
	margin-bottom: -160px;
	margin-top: 80px;

	.iv2-top-news__content {
		padding-top: 100px;
	}
}

.iv2-top-news-item .iv2-top-news-item__link {
	display: block;
	text-decoration: none;

	&:hover .iv2-top-news-item__img {
		opacity: 0.7;
	}

	.iv2-top-news-item__img {
		height: 250px;
		-webkit-transition: 0.3s;
		transition: 0.3s;
	}

	.iv2-top-news-item__date {
		font-size: 24px;
		line-height: 1;
		margin-right: 20px;
		padding-top: 3px;
	}

	.iv2-top-news-item__label {
		text-align: center;
		border: 1px solid;
		border-radius: 30px;
		line-height: 1;
		padding: 6px 40px;
		margin-right: 10px;
		background-color: #fff;
	}

	.iv2-top-news-item__new {
		color: #ff5c5c;
		border: 1px solid;
		border-radius: 30px;
		padding: 6px 10px;
		line-height: 1;
		background-color: #fff;
	}

	.iv2-top-news-item__title {
		font-size: 1.3rem;
		font-weight: bold;
		margin-top: 30px;
	}
}

@media (min-width: 1200px) {
	.iv2-top-news-item__list {
		padding: 0 100px;
	}
}

@media (max-width: 1199px) {
	.iv2-section-news {
		margin-bottom: -100px;
	}
	.iv2-top-news-item {
		.iv2-top-news-item__link {
			.iv2-top-news-item__date {
				font-size: 16px;
				padding-top: 8px;
			}

			.iv2-top-news-item__title {
				font-size: 1.1rem;
				margin-top: 10px;
			}
		}
	}
}
</style>
